export const CONNECTION_STATE = {
  ONLINE: 'online',
  OFFLINE: 'offline'
};
